import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Modal,
    Button,
    Loading
} from '@gpstrackit/gtc-react-controls';

import {
    Typography
} from '@mui/material';

import { NotificationManager } from 'Components/Notifications';

//actions
import {
    reset,
    closeDuplicateModal,
    duplicateForm
} from './redux/slice';

import {
    openDesignModal
} from '../design/redux/slice';



import './styles.scss';

const DuplicateForm = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { refresh } = props;

    const open = useSelector(state => state.dynamicFormsDuplicateRedux.open);
    const response = useSelector(state => state.dynamicFormsDuplicateRedux.response);
    const loading = useSelector(state => state.dynamicFormsDuplicateRedux.loading);
    const dynamicForm = useSelector(state => state.dynamicFormsDuplicateRedux.dynamicForm);
    const error = useSelector(state => state.dynamicFormsDuplicateRedux.error);

    useEffect(() => {
        if (open && response && !response?.error) {
            NotificationManager.success(
                messages['dynamicFormsDelete_successMessage'],
                messages['dynamicFormsDelete_success'],
                3000,
                null,
                null,
                'success',
                null
            );

            if (refresh) refresh();
            handleClose();
            dispatch(openDesignModal(response?.id));
        }
    }, [open, response]);

    useEffect(() => {
        if (open && error) {
            NotificationManager.error(
                response?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'warning',
            );

            handleClose();
            dispatch(reset({ error: false, response: null }));
        }
    }, [error, open, response]);

    const handleClose = useCallback(() => {
        dispatch(closeDuplicateModal());
        dispatch(reset());
    });

    return (
        <Modal
            title={`${messages['dynamicFormsDuplicte_title']} "${dynamicForm?.name}"`}
            open={open}
            loading={false}
            position="center"
            size="small"
            handleClose={handleClose}
            className='duplicate-form-modal-height'
            footer={(
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                    <Button
                        disabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        disabled={loading || !dynamicForm}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            if (dynamicForm) {
                                dispatch(duplicateForm({ id: dynamicForm?.id }));
                            }
                        }}
                        variant='primary'
                    >
                        {messages['dynamicFormsDuplicte_duplicate']}
                    </Button>
                </div>
            )}
        >
            <div className='duplicate-form-container'>
                {
                    loading ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Loading />
                        </div> :
                        <Typography
                            variant="subtitle2"
                            color="textSecondary"
                        >
                            {messages['dynamicFormsDuplicte_warning']}
                        </Typography>

                }
            </div>
        </Modal>
    );
}

export default DuplicateForm;